import React from 'react';
import { TOfferDataRequirement } from 'lendingApi/lapiOverrides.types';
import { DocumentRequirement } from '../../DocumentRequirement/DocumentRequirement';
import { Required } from '../../DocumentRequirement/Required';
import styles from './BankStatements.module.css';
import { LinkOpenBanking } from './LinkOpenBanking/LinkOpenBanking';

type TProps = {
  quantifier: number;
  isOptional: boolean;
  status?: TOfferDataRequirement['actions'][number]['status'];
  isSubmitted?: boolean;
  customerDetails: { email: string; firstName: string };
};

export const BankStatements = ({
  isOptional,
  quantifier,
  status,
  isSubmitted,
  customerDetails: { email, firstName },
}: TProps) => {
  return (
    <>
      <DocumentRequirement
        className={styles.bankStatements}
        title={
          <>
            Business bank statements for the last{' '}
            {quantifier > 1 ? `${quantifier} months` : '1 month'}
            {isSubmitted && (status === 'required' || status === 'error') && (
              <Required />
            )}
          </>
        }
        isOptional={isOptional}
        documentType="bank statement"
      >
        <ul>
          <li>
            These can be downloaded using online banking (
            <a
              href="https://6334445.fs1.hubspotusercontent-na1.net/hubfs/6334445/iwoca%20Bank%20Statement%20PDF%20Download%20Guide.pdf"
              target="_blank"
              rel="noreferrer"
            >
              See instructions
            </a>
            )
          </li>
          <li>Files must be PDF and no more than 2GB.</li>
          <li>
            These should be for the account(s) where the majority of the
            business revenue is generated.
          </li>
          <li>
            Please ensure the statements display the business name, sort code,
            account number and the account balance.
          </li>
        </ul>
      </DocumentRequirement>

      <LinkOpenBanking email={email} firstName={firstName} />
    </>
  );
};
